import React, {Component} from 'react'

import { Dialog } from "@blueprintjs/core";

const initialState = {
  isOpen: false,
  title: '',
  message: '',
  icon: 'pt-icon-issue',
  onClose: () => {}
}

class Alert extends Component {

  constructor (props) {
    super(props)

    this.state = {...initialState}
  }

  render () {
    let {isOpen, title, message, icon} = this.state

    return (
      <Dialog isOpen={isOpen} onClose={() => {this.onClose()}} title='Atenção' canEscapeKeyClose={false} canOutsideClickClose={false}>
        <div className="pt-dialog-body">
          <div className="pt-non-ideal-state">
            <div className="pt-non-ideal-state-visual pt-non-ideal-state-icon">
              <span className={`pt-icon ${icon}`}></span>
            </div>
            <h4 className="pt-non-ideal-state-title">{title}</h4>
            <div className="pt-non-ideal-state-description">
              {message}
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  onClose () {
    let {onClose} = this.state
    this.setState({...initialState})
    if (onClose) {
      onClose()
    }
  }

  show ({title, message, icon, onClose}) {
    this.setState({isOpen: true, title, message, icon, onClose})
  }
}

export default Alert


// WEBPACK FOOTER //
// ./src/components/alert/index.js